export const isRunningInJest = () => {
    if (typeof process !== 'undefined') {
        return process?.env?.REACT_APP_IN_JEST === 'true';
    }
    return false;
}